import React from 'react';
import Logo from 'components/Logo';
import useStyles from 'components/Header/style';

const Header = () => {
  const classes = useStyles();

  return (
    <header className={classes.header}>
      <div className={classes.headCont}>
        <div className={classes.headLogo}>
          <Logo />
        </div>
      </div>
    </header>
  );
};

export default Header;
